import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomAxios from '../utils/CustomAxios';
import { Box } from '@mui/material';
// 1. Import Components
// import { MediaPlayer, MediaProvider } from '@vidstack/react';

// // 2. Import Layouts (This is the line that was failing)
// import { DefaultVideoLayout, defaultLayoutIcons } from '@vidstack/react/player/layouts/default';

// // 3. Import Styles (Required for the layout to look right)
// import '@vidstack/react/player/styles/default/theme.css';
// import '@vidstack/react/player/styles/default/layouts/video.css';

// These paths exist in version 1.0+
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

const SecureVidstackPlayer = ({ videoGuid, aspectRatio }) => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [error, setError] = useState(null);

  // Fetch the secure signed URL from Django
  useEffect(() => {
    const fetchSecureUrl = async () => {
      try {
        const response = await CustomAxios.get(`videos/${videoGuid}/play/`);
        setVideoUrl(response.data.video_url);
      } catch (err) {
        console.error("Error fetching video key", err);
        setError("Unable to load video.");
      }
    };
    if (videoGuid) fetchSecureUrl();
  }, [videoGuid]);

  if (error) return <div className="text-red-500">{error}</div>;
  if (!videoUrl) return <div className="text-gray-500">Loading Player...</div>;

  return (
    <Box sx={{ 
      width: '100%', 
   
    }}>
      <MediaPlayer 
        src={videoUrl} 
        viewType="video" 
        streamType="on-demand" 
        logLevel="warn" 
        crossOrigin
        playsInline
        aspectRatio={aspectRatio}
      >
        <MediaProvider />
        
        {/* This 'DefaultVideoLayout' automatically generates:
           - Play/Pause
           - Scrubber
           - Volume
           - AND the Settings Menu (Quality, Speed) 
        */}
        <DefaultVideoLayout icons={defaultLayoutIcons} />
      </MediaPlayer>
    </Box>
  );
};

export default SecureVidstackPlayer;